import React, { useEffect } from 'react'
import 'bootstrap/dist/css/bootstrap.min.css';
import { useDarkMode } from '../utils/DarkModeProvider';
import stylesTableDarkMode from '../styles/TableDarkMode'
import stylesTableLightMode from '../styles/TableLightMode'
import { useGlobal } from '../utils/GlobalContext';
import InstanciasTablaHeader from './InstanciasTablaHeader';
import Instancias from './Instancias';
import TituloTabla from './TituloTabla';

export default function InstanciasTabla({ elem }) {

    const { setGlobalState } = useGlobal()

    const { darkMode } = useDarkMode();

    const dynamicStyles = darkMode ? stylesTableDarkMode : stylesTableLightMode;

    useEffect(() => {
        setGlobalState((prev) => {
            const yaExiste = prev.items.some(item => item.indice_completo === elem.indice_completo)
            if (yaExiste) return prev

            return {
                ...prev,
                items: [
                    ...prev.items,
                    {
                        "id_item_periodo": elem.id_item_periodo,
                        "indice_completo": elem.indice_completo,
                        "nombre": elem.item.nombre,
                        "notas": elem.notas ?? null,
                        "atributos": elem.atributos,
                        "instancias": []
                    }
                ]
            }
        })
    }, [])

    useEffect(() => {
        setGlobalState((prev) => {
            const nuevasInstancias = elem.instancias.map(instancia => ({
                "id": instancia.id,
                "estado": instancia.estado.estado,
                "valores": instancia.atributos.map(instanciaAtributo => ({
                    "id": instanciaAtributo.atributo.id,
                    "nombre": instanciaAtributo.atributo.nombre,
                    "tipo": instanciaAtributo.atributo.tipo,
                    "valor": instanciaAtributo.valor
                }))
            }))

            return {
                ...prev,
                items: prev.items.map(item =>
                    item.indice_completo === elem.indice_completo
                        ? {
                            ...item,
                            // No pisar instancias locales si el backend todavía devuelve vacío.
                            instancias:
                                nuevasInstancias.length > 0 || !Array.isArray(item.instancias) || item.instancias.length === 0
                                    ? nuevasInstancias
                                    : item.instancias
                        }
                        : item
                )
            }
        })
    }, [])

    return (
        <>
            <TituloTabla indice_completo={elem.indice_completo} nombre={elem.item.nombre} />
            <div style={{ marginBottom: 5, width: '100%', maxWidth: '100%', overflowX: 'auto' }}>
                <table style={{ width: 'max-content', minWidth: '100%', tableLayout: 'auto', borderCollapse: 'collapse' }}>
                    <InstanciasTablaHeader indice_completo={elem.indice_completo} nombre={elem.item.nombre} />
                    <tbody>
                        <Instancias indice_completo={elem.indice_completo} />
                    </tbody>
                </table>
            </div>
        </>
    )
}